

























  import EntetePage from '@/commun/components/entete-page/entete-page.vue';
  import { DemandesTableau } from '@/components/demandes/tableau';
  import { DemandesTableauColonnesNom } from '@/components/demandes/tableau/demandes-tableau-colonnes';
  import Demande from '@/domain/models/demande';
  import Routes from '@/router/routes';
  import Vue from 'vue';

  export default Vue.extend({
    name: 'DemandesFaculte',
    components: {
      EntetePage,
      DemandesTableau,
    },
    data: () => ({
      colonnesAffichees: [
        DemandesTableauColonnesNom.Numero,
        DemandesTableauColonnesNom.Session,
        DemandesTableauColonnesNom.Type,
        DemandesTableauColonnesNom.Faculte,
        DemandesTableauColonnesNom.CoursProgramme,
        DemandesTableauColonnesNom.Etat,
        DemandesTableauColonnesNom.Demandeur,
        DemandesTableauColonnesNom.Actions,
      ],
      routeConsulterDemande: Routes.ConsulterDemande,
    }),
    computed: {
      demandes(): Demande[] {
        return this.$store.getters.demandes;
      },
    },
    async created() {
      await this.$store.dispatch('obtenirDemandes');
    },
    methods: {
      onNaviguerCreerDemande(): void {
        this.$router.push({ name: Routes.DemandeType });
      },
    },
  });
